// extracted by mini-css-extract-plugin
export default {"container":"ProjectModalContent_container__p-QB3","buttonContainer":"ProjectModalContent_buttonContainer__JP7KD","button":"ProjectModalContent_button__RJgbN"};